import React from "react";

import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const store = useAppSelector(selectStore);

    return (
        <>
            See how people move around near your {store?.name} store and how long they spend in different areas.
            Compare parts of the retail centre to spot busier zones and plan how your store can make the most of them.
        </>
    );
};

export default Subtitle;
